import {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
// -
import {MiniQ2ValuesModel, MiniQ2HasModel} from "./models/MiniQ2Models";
import useCustomTranslation from "core/customTranslation";
import translations from "../../translations";
import RowTRComponent from "../../../components/RowTRComponent";


const MiniQ2Form = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...MiniQ2ValuesModel});
    const [has, setHas] = useState({...MiniQ2HasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};

    useEffect(() => {
        if (item.id) {
            setValues({...item.values});
            setHas({...item.has});
        } else {
            setValues({...MiniQ2ValuesModel});
            setHas({...MiniQ2HasModel});
        }
    }, [item]);

    const onChangeProtocol = (e) => {
        let values_ = {...values};
        values_.protocol = e.target.value;
        setValues({...values_});
    }

    return (
        <div className="row">
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-center">{_Tf("common.parameters")}</th>
                        <th style={{width: "35px", textAlign: "center"}}>{_Tf("common.actives")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{_TC("protocol")}</td>
                        <td>{_TC("protocol.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="protocol" className="form-label">{_TC("protocol")}</label>
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <Form.Select
                                        className="mb-2"
                                        id="protocol"
                                        name="protocol"
                                        value={values.protocol}
                                        title={_TC("protocol")}
                                        onChange={onChangeProtocol}
                                        style={{minWidth: "110px"}}
                                    >
                                        <option value="MQTT">MQTT</option>
                                        <option value="MQTTS">MQTTS</option>
                                    </Form.Select>
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}></td>
                    </tr>
                    <RowTRComponent
                        fieldName="ip"
                        _TC={_TC}
                        valueIn={values.ip}
                        hasIn={has.has_ip}
                        deactivated={MiniQ2ValuesModel.ip}
                        styleCenterMiddle={styleCenterMiddle}

                    />
                    <RowTRComponent
                        fieldName={"port"}
                        _TC={_TC}
                        valueIn={values.port}
                        hasIn={has.has_port}
                        deactivated={MiniQ2ValuesModel.port}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"user"}
                        _TC={_TC}
                        valueIn={values.user}
                        hasIn={has.has_user}
                        deactivated={MiniQ2ValuesModel.user}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"pass"}
                        _TC={_TC}
                        valueIn={values.pass}
                        hasIn={has.has_pass}
                        deactivated={MiniQ2ValuesModel.pass}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"client"}
                        _TC={_TC}
                        valueIn={values.client}
                        hasIn={has.has_client}
                        deactivated={MiniQ2ValuesModel.client}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"topic_data"}
                        _TC={_TC}
                        valueIn={values.topic_data}
                        hasIn={has.has_topic_data}
                        deactivated={MiniQ2ValuesModel.topic_data}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"topic_alerts"}
                        _TC={_TC}
                        valueIn={values.topic_alerts}
                        hasIn={has.has_topic_alerts}
                        deactivated={MiniQ2ValuesModel.topic_alerts}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"topic_control"}
                        _TC={_TC}
                        valueIn={values.topic_control}
                        hasIn={has.has_topic_control}
                        deactivated={MiniQ2ValuesModel.topic_control}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"topic_admin"}
                        _TC={_TC}
                        valueIn={values.topic_admin}
                        hasIn={has.has_topic_admin}
                        deactivated={MiniQ2ValuesModel.topic_admin}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default MiniQ2Form